import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useStockList } from '../../../../libs/hooks';
import { Autocomplete } from '@material-ui/lab';
import { InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles(theme => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  }
}));

const ProfitEditModal = ({ editItem, visible, close, onPressSubmit }) => {
  const classes = useStyles();
  const [item, setItem] = useState(editItem);
  const [inputVal, setInputVal] = useState('');

  const stocks = useStockList();

  useEffect(() => {
    setItem({ ...editItem });
  }, [editItem]);

  const handleChange = event => {
    const { id } = event.currentTarget;
    const { value } = event.target;

    switch (id) {
      case 'price':
        setItem(prev => ({
          ...prev,
          estimatedPrice: Number(value.replace(/[^0-9]/g, ''))
        }));
        break;
      case 'opinion':
        setItem(prev => ({ ...prev, opinion: value }));
        break;
      default:
        break;
    }
  };

  if (!item) return null;

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={visible}
      onClose={close}
    >
      <DialogTitle>{item.id ? '수정' : '추가'}</DialogTitle>
      <DialogContent>
        <div className={classes.formContainer}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Autocomplete
              id={'code'}
              value={
                item.code ? { code: item.code, codeName: item.codeName } : null
              }
              onChange={(_, newValue) => {
                if (!newValue)
                  return setItem(prev => ({ ...prev, code: '', codeName: '' }));

                setItem(prev => ({ ...prev, ...newValue }));
              }}
              inputValue={inputVal}
              onInputChange={(event, newInputValue) => {
                setInputVal(newInputValue);
              }}
              style={{ width: 300 }}
              options={inputVal.length ? stocks : []}
              getOptionLabel={option =>
                option.code ? `${option.codeName} (${option.code})` : ''
              }
              getOptionSelected={(option, value) =>
                value.code ? option.code === value.code : false
              }
              renderInput={params => (
                <TextField {...params} label="종목" variant="outlined" />
              )}
            />
          </FormControl>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="opinion-label">{'의견'}</InputLabel>
            <Select
              label={'의견'}
              labelId={'opinion-label'}
              id={'opinion'}
              value={item.opinion || ''}
              onChange={handleChange}
            >
              <MenuItem id={'opinion'} value={''}>
                <em>None</em>
              </MenuItem>
              <MenuItem id={'opinion'} value={'BUY'}>
                {'BUY'}
              </MenuItem>
              <MenuItem id={'opinion'} value={'SELL'}>
                {'SELL'}
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" className={classes.formControl}>
            <TextField
              value={item.estimatedPrice || 0}
              label={'예상금액'}
              id={'price'}
              onChange={handleChange}
              variant={'outlined'}
            />
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          {'취소'}
        </Button>
        <Button
          onClick={() => {
            onPressSubmit(item);
            close();
          }}
          color="primary"
        >
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfitEditModal;
